import { render, staticRenderFns } from "./FileDisplay.vue?vue&type=template&id=5266cd6c&scoped=true&"
import script from "./FileDisplay.vue?vue&type=script&lang=js&"
export * from "./FileDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FileDisplay.vue?vue&type=style&index=0&id=5266cd6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5266cd6c",
  null
  
)

export default component.exports